import { zodResolver } from '@hookform/resolvers/zod';
import type { FieldErrors, Resolver } from 'react-hook-form';
import type { z } from 'zod';

/**
 * zodResolver for schemas whose messages are translation keys: each top-level
 * field error message is passed through `t`, so schemas stay free of i18n.
 */
export const translatedZodResolver =
  <TSchema extends z.ZodTypeAny>(
    schema: TSchema,
    t: (key: string) => string
  ): Resolver<z.infer<TSchema>> =>
  async (data, context, options) => {
    const result = await zodResolver(schema)(data, context, options);
    if (result.errors) {
      result.errors = Object.fromEntries(
        Object.entries(result.errors).map(([key, error]) => [
          key,
          { ...error, message: t((error as { message?: string }).message ?? '') },
        ])
      ) as FieldErrors<z.infer<TSchema>>;
    }
    return result;
  };
